export default __webpack_public_path__ + "static/media/thinking.69bb5e87.gif";